import { Link } from 'react-router-dom';
import { latestUpdates, comics } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              热门韩漫最新章节第一时间上线
            </p>
          </div>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {latestUpdates.map((update, index) => {
            const comic = comics.find((c) => c.id === update.comicId);
            if (!comic) return null;
            return (
              <Link
                key={`${update.comicId}-${update.chapter}`}
                to={`/article/${update.comicId}`}
                className={`flex items-center gap-4 px-5 py-3.5 hover:bg-background-100 transition-colors no-underline group ${
                  index < latestUpdates.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className="flex-shrink-0 w-10 h-14 rounded overflow-hidden">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    {update.chapter}：{update.title}
                  </p>
                </div>
                <div className="flex-shrink-0 flex items-center gap-3">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {update.date}
                  </span>
                  <span className="px-2 py-0.5 text-xs bg-primary-100 text-primary-700 rounded-full font-medium whitespace-nowrap">
                    新
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}